module.exports = __webpack_public_path__ + "img/beer_id-101.b442700c.png";